@use 'themes/westfield' as *;
// Label styles
// ============

@use 'tools/dirg' as *;
@use 'tools/color' as *;
@use 'tools/if-theme' as *;
@use 'tools/typography.module' as *;

.Label {
  color: color('Black');
  cursor: pointer;

  @extend .bodyFont;

  @include if-theme('scentregroup') {
    @extend .bodyFont;
    color: color('Grey Dark');
  }
}

.LabelDefault {
  @extend .heading;
  font-size: font-scale(2);
  line-height: units(1.5);
}

.LabelSmall {
  @extend .paragraphSmall;
}

.labelWrapper {
  display: flex;
  align-items: center;
}

.SubLabel {
  @include font-size(1);
  composes: Label;
  font-weight: normal;
}

.SubLabelSmall {
  @include font-size(0);
  composes: Label;
  font-weight: normal;
}
